 
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import { BlogsTitle, ReadMore } from "../../../constants";
import { BlogsContentData, BlogsData } from "../../../data/demo/CarDemo2";
import { routes } from "../../../routers/routes";
import { dynamicImage, dynamicSvg, Image } from "../../../utils";
import RatioImage from "../../../utils/RatioImage";
import VideoModal from "../../commonComponents/modals/VideoModal";
import CommonHeader from "../common/CommonHeader";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { setVideoModal } from "../../../reduxToolkit/reducers/layoutSlice";

const Blogs = () => {
  const dispatch = useAppDispatch();
  return (
    <>
      <section className="car2-blog-section section-t-lg-space section-b-lg-space overflow-hidden">
        <RatioImage src={dynamicImage("car2/bg-effect/featured-bg.png")} alt="featured-bg" className="bg-img" />
        <Container>
          <CommonHeader title={BlogsTitle} content={BlogsContentData} titleClass="text-white" headClass="title-style-5" />
          <Row className="justify-content-center gy-4">
            <Col lg="6" sm="8" className="d-lg-block d-none">
              <div className="main-blog-img position-relative">
                <Image src={dynamicImage("car2/blog/1.jpg")} alt="b-1" className="img-fluid w-100 main-img" />
                <Button className="btn-play" onClick={() => dispatch(setVideoModal())}>
                  <Image src={dynamicSvg("car2/play.svg")} alt="play" className="img-fluid" />
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <ul className="blog-list">
                {BlogsData.map((blog, index) => (
                  <li key={index}>
                    <Link to={routes.Pages.Blog.Detail.BlogLeftClassic} className="blog-img">
                      <Image src={dynamicImage(blog.image)} alt={`blog-${index + 2}`} className="img-fluid" />
                    </Link>
                    <div className="blog-content">
                      <Link to={routes.Pages.Blog.Detail.BlogLeftClassic} className="blog-title">
                        {blog.title}
                      </Link>
                      <p>{blog.text}</p>
                      <Link to={routes.Pages.Blog.Detail.BlogLeftClassic} className="text-btn">
                        {ReadMore} <i className="ri-arrow-right-line" />
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
      <VideoModal />
    </>
  );
};

export default Blogs;
